import styled from "styled-components";
import { colors } from "../../../theme/colors";
import { Grid, Typography } from "@mui/material";

export const StyledFooterWrapper = styled.div`
  height: 750px;
  background-color: ${colors.primary};
  display: flex;
  align-items: center;
  padding: 10rem 10rem;

  @media (max-width: 1024px) {
    padding: 3rem 32px;
    height: max-content;
  }

  @media (max-width: 768px) {
    padding: 3rem 32px;
    height: max-content;
  }
`;

export const StyledFooterGrid = styled(Grid)`
  width: 90% !important;
  margin: 0 auto !important;
  height: 100%;
  display: flex !important;
  flex-direction: row !important;
  justify-content: space-between;

  @media (max-width: 768px) {
    text-align: center;
    justify-content: flex-start !important;
    gap: 2rem;
  }
`;

export const LinkText = styled(Typography)`
  color: ${colors.secondary} !important;
  cursor: pointer;
  background: none;
  border: none;
  padding: 0;
  font-size: 1rem !important;
  text-align: left;
  text-decoration: none;
  transition: opacity 0.3s ease;

  &:hover {
    opacity: 0.8;
    text-decoration: underline;
  }

  @media (max-width: 768px) {
    text-align: center;
  }
`;

export const SocialIconsContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 3rem;
  margin: 4rem 0 2rem 0;
  color: ${colors.secondary};

  @media (max-width: 768px) {
    gap: 2rem;
    margin: 0rem;
  }
`;

export const ContactInfo = styled.div`
  text-align: center;
  margin-top: 2rem;

  @media (max-width: 768px) {
    margin-top: 0rem;
  }
`;

export const OtherLinks = styled.div`
  display: flex;
  text-align: center;
  flex-direction: column;
  gap: 1rem;

  @media (max-width: 768px) {
    align-items: flex-start !important;
  }
`;
